import {
  CheckCircleRounded,
  Facebook,
  Message,
  MoreVert,
  Star,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Rating,
  styled,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./AgencyCardItemNew.css";

const decodeLocalData = (name) => {
  let result = atob(window.localStorage.getItem(name));
  return JSON.parse(result);
};
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

const AgencyCardItemNew = (props) => {
  const navigate = useNavigate();
  const { agencyData } = props;

  const {
    active_state,
    email,
    location,
    name,

    pic,
    refer_id,
    sopnoId,
    sub_category_info,
    category_info,
    user_rate,
    user_state,
    user_skill,
    agency_info,
    poster_info,
  } = agencyData;

  const { cname, cinfo, cslogan, cskill } = agency_info;
  return (
    <Card
      sx={{
        cursor: "pointer",
        borderRadius: "12px",
        "&:hover": {
          boxShadow: "5px 5px 15px grey;",
        },
      }}
      onClick={() => {
        navigate("/profiledetails/" + sopnoId);
        // navigate("/" + sopnoId);
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(to right, #00C9A7, #0094E4)",
          height: 80,
        }}
      />

      <CardContent sx={{ mt: "-55px" }}>
        <Box>
          <Stack spacing={2} justifyContent="left" alignItems="center">
            {/* {active_state?.[0]?.state === 1 ? (
              <StyledBadge badgeContent={""} color="success" variant="dot">
                <Avatar
                  alt="Remy Sharp"
                  src={
                    poster_info?.user_pic?.[0]
                      ? "//yeapbe.com/" + poster_info?.user_pic?.[0]?.pic_url
                      : agency_info?.agency_logo?.[0]
                      ? "//yeapbe.com/" + agency_info?.agency_logo?.[0]?.pic_url
                      : "https://ghorami.com/image/web_admin/data_entry.jpg"
                  }
                  sx={{ width: 90, height: 90, border: "4px solid white" }}
                />
              </StyledBadge>
            ) : (
              <StyledBadge badgeContent={""} color="grey" variant="dot">
                <Avatar
                  alt="Remy Sharp"
                  src={
                    poster_info?.user_pic?.[0]
                      ? "//yeapbe.com/" + poster_info?.user_pic?.[0]?.pic_url
                      : agency_info?.agency_logo?.[0]
                      ? "//yeapbe.com/" + agency_info?.agency_logo?.[0]?.pic_url
                      : "https://ghorami.com/image/web_admin/data_entry.jpg"
                  }
                  sx={{ width: 90, height: 90, border: "4px solid white" }}
                />
              </StyledBadge>
            )} */}

            <StyledBadge
              overlap="circular"
              variant="dot"
              color={active_state?.[0]?.state === 1 ? "success" : "default"}
            >
              <Avatar
                src={
                  agency_info?.agency_logo?.[0]
                    ? "//yeapbe.com/" + agency_info?.agency_logo?.[0]?.pic_url
                    : poster_info?.user_pic?.[0]
                    ? "//yeapbe.com/" + poster_info?.user_pic?.[0]?.pic_url
                    : "https://ghorami.com/image/web_admin/data_entry.jpg"
                }
                alt={poster_info?.Name}
                sx={{
                  width: 72,
                  height: 72,
                  border: "3px solid white",
                }}
              />
            </StyledBadge>

            <Stack spacing={7} justifyContent="center" alignItems="center">
              <Box sx={{ height: "42px" }}>
                <Stack
                  direction={"row"}
                  justifyContent="center"
                  alignItems="center"
                >
                  {user_state?.[0]?.states === 1 ? (
                    <Box
                      className="verificationContainer"
                      sx={{ cursor: "pointer", position: "relative" }}
                    >
                      <CheckCircleRounded
                        color="success"
                        sx={{
                          fontSize: "13pt !important",
                          fontWeight: 700,
                          marginTop: "5px",
                        }}
                      />

                      <Stack
                        direction={"row"}
                        justifyContent="center"
                        alignItems="flex-start"
                        className="verification"
                        sx={{
                          position: "absolute",
                          top: "-70%",
                          left: "-110%",
                          opacity: 0,
                        }}
                      >
                        <Typography
                          variant="p"
                          sx={{
                            fontSize: "9pt",
                            fontWeight: 600,
                            color: "white",
                            backgroundColor: "#8CC986",
                            ml: "-5px",
                            px: "10px",
                            py: 0,
                            borderRadius: "8px",
                          }}
                        >
                          Verified
                        </Typography>
                      </Stack>
                    </Box>
                  ) : (
                    <Box
                      className="verificationContainer"
                      sx={{ cursor: "pointer", position: "relative" }}
                    >
                      <CheckCircleRounded
                        color="grey"
                        sx={{
                          fontSize: "11pt",
                          fontWeight: 700,
                          marginTop: "5px",
                        }}
                      />

                      <Stack
                        direction={"row"}
                        justifyContent="center"
                        alignItems="flex-start"
                        className="verification"
                        sx={{
                          position: "absolute",
                          top: "-70%",
                          left: "-150%",
                          opacity: 0,
                        }}
                      >
                        <Typography
                          variant="p"
                          sx={{
                            fontSize: "9pt",
                            fontWeight: 600,
                            color: "white",
                            backgroundColor: "gray",
                            ml: "-5px",
                            px: "10px",
                            py: 0,
                            borderRadius: "8px",
                          }}
                        >
                          Unverified
                        </Typography>
                      </Stack>
                    </Box>
                  )}

                  <Typography
                    variant="p"
                    sx={{
                      textAlign: "center",
                      fontSize: "12pt",
                      fontWeight: 600,
                      ml: "3px",
                    }}
                  >
                    {agency_info?.cname
                      ? agency_info?.cname?.slice(0, 20)
                      : poster_info?.Name
                      ? poster_info?.Name?.slice(0, 20)
                      : name}
                    {agency_info?.cname
                      ? agency_info?.cname?.length >= 20 && "..."
                      : poster_info?.Name
                      ? poster_info?.Name?.length >= 20 && "..."
                      : name}
                  </Typography>
                </Stack>
                <Stack
                  direction={"row"}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography
                    variant="p"
                    sx={{ textAlign: "center", fontSize: "11pt" }}
                  >
                    {cskill
                      ? cskill
                      : cslogan
                      ? cslogan
                      : user_skill?.[0]
                      ? user_skill?.[0]?.tag
                      : category_info?.[0]?.title
                      ? category_info?.[0]?.title +
                        ", " +
                        sub_category_info?.[0]?.title
                      : ""}
                  </Typography>
                </Stack>
              </Box>
              <Stack
                spacing={0}
                direction="row"
                justifyContent="left"
                alignItems="center"
              >
                <Typography
                  variant="p"
                  color="white"
                  sx={{
                    ml: "2px",
                    fontSize: { xs: "7pt", md: "10pt" },
                    fontWeight: 600,
                    backgroundColor: "#FDBD45",
                    padding: "0 5px",
                  }}
                >
                  {user_rate?.average_rating != 0 ||
                    (user_rate?.average_rating != 0.0 &&
                      user_rate?.average_rating)}
                </Typography>
                <Rating
                  name="read-only"
                  value={user_rate?.average_rating}
                  readOnly
                  sx={{ fontSize: "14pt" }}
                />
                <Typography
                  variant="p"
                  color="black"
                  sx={{
                    ml: "2px",
                    fontSize: { xs: "7pt", md: "10pt" },
                    fontWeight: 600,
                  }}
                >
                  ({user_rate?.total_review} Reviews)
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Box>
        {/* <Stack
          direction={"row"}
          justifyContent="center"
          alignItems="flex-start"
          className="verification"
          sx={{ position: "absolute", top: "40%", opacity: 0 }}
        >
          <Typography
            variant="p"
            sx={{
              fontSize: "8pt",
              fontWeight: 600,
              color: "white",
              backgroundColor: "#8CC986",
              ml: "-5px",
              px: "10px",
              py: 0,
              borderRadius: "8px",
            }}
          >
            Varified
          </Typography>
        </Stack> */}
      </CardContent>

      {/* <Stack
        direction={"row"}
        justifyContent="space-between"
        alignItems="center"
        sx={{
          marginBottom: "20px",
          padding: "20px",
        }}
      >
        <Button
          variant="contained"
          sx={{
            width: "50%",
            backgroundColor: "#14506A",
            "&:hover": {
              backgroundColor: "#22AB7D",
            },
          }}
          size="small"
          onClick={() => {
            navigate("/" + sopnoId);
          }}
        >
          Profile
        </Button>
        <IconButton aria-label="delete">
          <Message />
        </IconButton>
      </Stack> */}
    </Card>
  );
};

export default AgencyCardItemNew;
